import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import ApiService from './api.service.abstract';
import { Country } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import { CacheBucket, withCache } from '@ngneat/cashew';

@Injectable({ providedIn: 'root' })
export class CountryService extends ApiService<Country> {
  countriesChangedSubject: Subject<Country[]> = new Subject<Country[]>();
  countryBucket: CacheBucket = new CacheBucket();

  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'trip/api/geo/countries');
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:8082';
    }
  }

  public findAllWithCache(): Observable<HttpResponse<Country[]>> {
    return this.http.get<Country[]>(`${this.url}/${this.endpoint}`, {
      observe: 'response',
      context: withCache({
        bucket: this.countryBucket,
        key: 'countries',
        ttl: 15 * 60 * 1000,
      }),
    });
  }

  public findAllHotelbedsWithCache(): Observable<HttpResponse<Country[]>> {
    return this.http.get<Country[]>(`${this.url}/api/countries/hotelbeds`, { // backend-owned, not migrated
      observe: 'response',
      context: withCache({
        bucket: this.countryBucket,
        key: 'countries-hotelbeds',
        ttl: 15 * 60 * 1000,
      }),
    });
  }
}
